export default [
  'TermsAndConditions'
]

/*
Appears on:
/terms-and-conditions
*/
